import React, { useContext, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../utils/AlertContext";
import { apiRoutes } from "../../../utils/apiRoutes";
import { createData } from "../../../utils/methods";

const UserAdded = ({ onCloseClick, newUser }) => {
  const { t } = useContext(TranslationsContext);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePrint = () => {
    // Must be called synchronously within the click handler to count as a
    // direct user gesture — Safari silently refuses to open the dialog
    // otherwise. The printable content itself lives in a separate portal
    // (see below) that's always rendered, so there's no state to flush first.
    window.print();
  };

  const handleSendPassword = async () => {
    // setIsLoading(true);
    const sendData = {
      osoba: {
        id: newUser.id,
        ime: newUser.ime,
        prezime: newUser.prezime,
        username: newUser.username,
        sifra: newUser.password,
        email: newUser.username,
        dogadjaj: {
          naziv: "Dogadjaj 1",
        },
      },
    };
    try {
      const result = await createData(
        apiRoutes.sendPassword,
        sendData,
        showAlert,
        navigate,
        t,
      );

      if (!result) return;

      console.log("Podaci su uspešno sačuvani:", result.data);
      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    // Handle Enter key to trigger send password action
    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" && target.type !== "submit")
        ) {
          return;
        }
        event.preventDefault();
        handleSendPassword();
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [newUser]);

  return (
    <div className="flex-direction-column gap-24 user-added-modal-wrapper">
      <div className="flex-direction-column gap-24 width-100 modal-content">
        <div className="flex-direction-row justify-between width-100">
          <p className="inria-sans-400 font-24 modal-title">
            {t("USER_ADDED_TITLE")}
          </p>
          <img
            className="pointer"
            src={icons.close_gray}
            onClick={() => {
              onCloseClick();
            }}
            alt="X"
          />
        </div>
        <p className="inria-sans-400 font-14 user-added-description">
          {t("USER_ADDED_DESCRIPTION")}
        </p>
        <div className="flex-direction-column gap-12 width-100">
          <div className="flex-direction-row items-center justify-between width-100 user-added-field">
            <p className="inria-sans-400 font-14 user-added-field-label">
              {t("USERNAME")}
            </p>
            <input
              className="inria-sans-700 font-14 user-added-field-value"
              type={"text"}
              value={newUser?.username}
              readOnly
            />
          </div>

          <div className="flex-direction-row items-center justify-between width-100 user-added-field">
            <p className="inria-sans-400 font-14 user-added-field-label">
              {t("PASSWORD")}
            </p>
            <input
              className="inria-sans-700 font-14 user-added-field-value"
              type={showPassword ? "text" : "password"}
              value={newUser?.password}
              readOnly
              onMouseEnter={() => setShowPassword(true)}
              onMouseLeave={() => setShowPassword(false)}
            />
          </div>
        </div>
      </div>
      <div className="flex-direction-row user-added-actions">
        <AccreditationButton
          type="close"
          title={t("PRINT")}
          className="user-added-print-btn"
          onClick={handlePrint}
        />
        <AccreditationButton
          type="save"
          title={t("SEND_PASSWORD")}
          className="user-added-send-btn"
          onClick={handleSendPassword}
        />
      </div>
      {createPortal(
        <div className="print-only user-added-print-sheet">
          <div className="user-added-print-row">
            <span className="user-added-print-label">{t("USERNAME")}</span>
            <span className="user-added-print-value">{newUser?.username}</span>
          </div>
          <div className="user-added-print-row">
            <span className="user-added-print-label">{t("PASSWORD")}</span>
            <span className="user-added-print-value">{newUser?.password}</span>
          </div>
        </div>,
        document.body,
      )}
    </div>
  );
};

export default UserAdded;
